import React, { useState } from 'react';
import { FaShoppingCart, FaPhone, FaWhatsapp, FaBars, FaTimes } from 'react-icons/fa';
import DairyzarLogo from './Logo';
import '../styles/Header.css';

const Header = ({ cartCount, onCartClick }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <>
      <div className="announcement-bar">
        Free Shipping on Orders Above Rs. 3000
      </div>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <DairyzarLogo width={160} height={50} />
            </div>

            <button className="menu-toggle" onClick={toggleMenu}>
              {menuOpen ? <FaTimes /> : <FaBars />}
            </button>

            <nav className={`nav ${menuOpen ? 'active' : ''}`}>
              <ul>
                <li><a href="#home" onClick={() => scrollToSection('home')}>Home</a></li>
                <li><a href="#products" onClick={() => scrollToSection('products')}>Products</a></li>
                <li><a href="#features" onClick={() => scrollToSection('features')}>Why Us</a></li>
                <li><a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a></li>
              </ul>
            </nav>

            <div className="header-actions">
              <a href="tel:+923126108161" className="phone-link">
                <FaPhone /> <span>0312 6108161</span>
              </a>
              <a href="https://wa.me/923126108161" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                <FaWhatsapp />
              </a>
              <button className="cart-btn" onClick={onCartClick}>
                <FaShoppingCart />
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;